import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  FormFor,
  Label,
  TextArea,
  Submit,
  CheckBox,
} from "react-rails-form-helpers";
import classNames from "classnames";

class NewEngagementForm extends Component {
  state = {
    minimumMessageLength: 70,
    allowedMessageLength: 350,
    messageLength: 0,
    charactersRemaining: undefined,
    hasConfirmedCustomTerms: false,
    hasConfirmedCustomTermsError: null,
  };

  componentDidMount() {
    this.setState((previousState) => ({
      charactersRemaining: previousState.allowedMessageLength,
    }));
  }

  updateCharactersRemaining = (event) => {
    event.preventDefault();
    const messageLength = event.target.value.length;
    const charactersRemaining = (allowedLength) =>
      allowedLength - messageLength;

    this.setState(({ allowedMessageLength }) => ({
      charactersRemaining: charactersRemaining(allowedMessageLength),
      messageLength,
    }));
  };

  updateTermsAcceptance = (event) => {
    this.setState({ hasConfirmedCustomTerms: event.target.checked });
  };

  checkTerms = (event) => {
    const { hasConfirmedCustomTerms } = this.state;
    const { hasCustomTerms, recruiterIsInJobAudience } = this.props;
    if (
      hasCustomTerms &&
      !hasConfirmedCustomTerms &&
      !recruiterIsInJobAudience
    ) {
      event.preventDefault();
      this.setState(() => ({
        hasConfirmedCustomTermsError:
          "You must agree to the employer’s specific Terms of Business",
      }));
    }
  };

  render() {
    const {
      createEngagementPath,
      updateEngagementPath,
      hasCustomTerms,
      recruiterIsOnPsl,
      recruiterIsInJobAudience,
      isPartnerUser,
    } = this.props;

    const {
      allowedMessageLength,
      charactersRemaining,
      hasConfirmedCustomTerms,
      hasConfirmedCustomTermsError,
      messageLength,
      minimumMessageLength,
    } = this.state;

    const underMinimumLength =
      !recruiterIsOnPsl &&
      !isPartnerUser &&
      messageLength < minimumMessageLength;

    const minTextClass = classNames({
      "col-xs-6 min-text-help": true,
      "col-xs-6 min-text-under-threshold": underMinimumLength,
    });

    const charsRemainingClass = classNames({
      "col-sm-6 chars-remaining": true,
      "col-xs-6 limit-exceeded": charactersRemaining < 1,
      "col-xs-6 limit-approaching": charactersRemaining < 100,
    });

    const submitButtonText = () => {
      if (recruiterIsOnPsl) {
        return "Engage";
      }
      if (isPartnerUser) {
        return "Accept";
      }
      return "Request Engagement";
    };

    return (
      <div id="form-engagement-modal">
        <FormFor
          id="engage_form"
          url={isPartnerUser ? updateEngagementPath : createEngagementPath}
          method={isPartnerUser ? "patch" : "post"}
          name="engagement"
          onSubmit={this.checkTerms}
        >
          {!recruiterIsOnPsl && !isPartnerUser && (
            <div>
              <div className="row message-label-info">
                <div className="col-sm-1 message-label">Message</div>
              </div>
              <div className="form-group">
                <TextArea
                  id="engagement-message"
                  className="form-control eng-msg-text form-control"
                  name="message"
                  placeholder="Enter your message here..."
                  onChange={this.updateCharactersRemaining}
                  maxLength={allowedMessageLength}
                />
                <div className={minTextClass}>
                  Minimum of {minimumMessageLength} characters
                </div>
                <div className={charsRemainingClass}>
                  {charactersRemaining} characters remaining
                </div>
              </div>
            </div>
          )}
          {hasCustomTerms && !recruiterIsInJobAudience && (
            <div className="form-group">
              <div className="checkbox">
                <p className="terms-label">
                  This employer utilises their own Terms of Business. Please
                  confirm you have read and agree to the employer’s specific
                  Terms of Business before engaging as they differ from Hiring
                  Hub&apos;s standard terms:
                </p>
                <br />
                <div className="checkbox-wrapper">
                  <Label htmlFor="custom-terms-checkbox">
                    <CheckBox
                      name="has_confirmed_custom_terms"
                      className="terms-checkbox"
                      id="custom-terms-checkbox"
                      type="checkbox"
                      onChange={this.updateTermsAcceptance}
                      value={hasConfirmedCustomTerms}
                    />
                    Agree to employer’s specific Terms of Business?
                  </Label>
                </div>
                <div className="help-block with-errors">
                  {hasConfirmedCustomTermsError}
                </div>
              </div>
            </div>
          )}

          <div className="text-center buttons">
            <button
              type="button"
              className="btn btn-tertiary-new"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <Submit
              name="commit"
              data-test-id="request-engagement-submit-button"
              id="engage-modal-submit"
              className="btn btn-primary"
              value={submitButtonText()}
              disabled={underMinimumLength}
            />
          </div>
        </FormFor>
      </div>
    );
  }
}

NewEngagementForm.propTypes = {
  createEngagementPath: PropTypes.string.isRequired,
  updateEngagementPath: PropTypes.string.isRequired,
  hasCustomTerms: PropTypes.bool.isRequired,
  recruiterIsOnPsl: PropTypes.bool,
  recruiterIsInJobAudience: PropTypes.bool,
  isPartnerUser: PropTypes.bool.isRequired,
};

NewEngagementForm.defaultProps = {
  recruiterIsOnPsl: false,
  recruiterIsInJobAudience: false,
};

export default NewEngagementForm;
